module.exports = __webpack_public_path__ + "img/img01.c8ea6b7a.png";